// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  Corporate: (t, data?, options?) => t('enum.subscription-type.corporate.name', data, options),
  Coupon: (t, data?, options?) => t('enum.subscription-type.coupon.name', data, options),
  Free: (t, data?, options?) => t('enum.subscription-type.free.name', data, options),
  None: (t, data?, options?) => t('enum.subscription-type.none.name', data, options),
  Periodic: (t, data?, options?) => t('enum.subscription-type.periodic.name', data, options),
  Trial: (t, data?, options?) => t('enum.subscription-type.trial.name', data, options),
  /* eslint-enable max-len */
};

export const description: ITranslationTable = {
  /* eslint-disable max-len */
  Corporate: (t, data?, options?) => t('enum.subscription-type.corporate.description', data, options),
  Coupon: (t, data?, options?) => t('enum.subscription-type.coupon.description', data, options),
  Free: (t, data?, options?) => t('enum.subscription-type.free.description', data, options),
  None: (t, data?, options?) => t('enum.subscription-type.none.description', data, options),
  Periodic: (t, data?, options?) => t('enum.subscription-type.periodic.description', data, options),
  Trial: (t, data?, options?) => t('enum.subscription-type.trial.description', data, options),
  /* eslint-enable max-len */
};
